The actual position profile.
